import { PersonsNamesService_personNameServiceGetEntities as service } from '@festina/legalentity-general-types/legalentity/hooks/PersonsNamesService_personNameServiceGetEntities'

export const useFetchPersonNames = service.useSuspenseQuery
